import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';

interface MultiCardOfferDialogProps {
  open: boolean;
  cardCount: number;
  /** Split the screenshot into that many image cards. */
  onSplit: () => void;
  /** Add the screenshot to the carousel as a single slide instead. */
  onAddOne: () => void;
  onCancel: () => void;
}

/**
 * Shown after a pasted image into the Image Cards block is detected as a row/grid
 * of captioned photos — offers to split it into cards or keep it as one slide.
 */
export default function MultiCardOfferDialog({
  open,
  cardCount,
  onSplit,
  onAddOne,
  onCancel,
}: MultiCardOfferDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" aria-labelledby="multi-card-offer-title">
      <DialogTitle id="multi-card-offer-title">This looks like {cardCount} image cards</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The screenshot seems to be {cardCount} photos, each with a heading and description. Split
          it into {cardCount} cards, or add the whole screenshot as one slide?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={onAddOne}>Add as one slide</Button>
        <Button onClick={onSplit} variant="contained">
          Split into {cardCount} cards
        </Button>
      </DialogActions>
    </Dialog>
  );
}
